import { useMemo } from 'react';
import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from '../hooks/usePublicFeatureFlags';
import { getManualI18nLang } from '../setup/i18nGlobals';
import { buildPageSchema } from './buildPageSchema';
import { JsonLdScript } from './JsonLdScript';
import { jsx as _jsx } from "react/jsx-runtime";
export function PublicPageSchema({
  productGroup,
  cards,
  currencyCode
}) {
  var _getManualI18nLang;
  const {
    featureFlags,
    loading
  } = usePublicFeatureFlags();
  const locale = (_getManualI18nLang = getManualI18nLang()) !== null && _getManualI18nLang !== void 0 ? _getManualI18nLang : 'en';
  const isEnabled = !loading && featureFlags.includes(FeatureFlags.PUBLIC_PRICING_PAGE_SCHEMA) && locale === 'en';
  const schema = useMemo(() => isEnabled ? buildPageSchema({
    productGroup,
    cards: cards.filter(c => !c.hasBundledProducts),
    currencyCode,
    locale
  }) : null, [isEnabled, productGroup, cards, currencyCode, locale]);
  if (!schema) return null;
  return /*#__PURE__*/_jsx(JsonLdScript, {
    schema: schema
  });
}